<script lang="ts">
	import Image from '$lib/components/images/Image.svelte'
	import Link from '$lib/components/Link.svelte'
	import PostMeta from '$lib/components/PostMeta.svelte'
	import { setPostPictures } from '$lib/post-pictures-context.svelte'
	import type { PageData } from './$types'

	interface Props {
		data: PageData
	}

	// don't destructure to maintain reactivity for invalidation after language detection
	let { data }: Props = $props()

	let {
		title,
		metaTitle,
		date,
		description,
		image,
		author,
		showImage = true,
		showTitle = true
	} = $derived({ title: data.slug, ...data.meta })
	let parent = $derived(data.slug.split('/').slice(0, -1).join('/'))

	// Expose server-resolved Picture objects to the markdown <img> renderer so
	// it can use Image directly instead of bundling the glob resolver.
	// setContext must run during component init (not in $effect) so children
	// can read it during their own init; data.pictures is set per-navigation.
	setPostPictures(data.pictures ?? {})
</script>

<svelte:head>
	{#each data.cssUrls ?? [] as href}
		<link rel="stylesheet" {href} />
	{/each}
</svelte:head>

<PostMeta title={metaTitle ?? title} {description} {date} image={data.metaImageUrl} />

<article>
	{#if parent}
		<Link href={`/${parent}`}>View all {parent}</Link>
	{/if}
	{#if showTitle !== false}
		<hgroup>
			<h1>{title}</h1>
			{#if author}
				<p>{author}</p>
			{/if}
			{#if date}
				<!-- <p>Published at {formatDate(date)}</p> -->
			{/if}
		</hgroup>
	{/if}

	{#if image && showImage !== false}
		<div class="banner">
			<Image
				picture={data.banner?.picture ?? null}
				src={data.banner?.assetUrl ?? image}
				alt={title}
				aspectRatio={1200 / 628}
			/>
		</div>
	{/if}

	<div class="prose">
		<data.content />
	</div>
</article>

<style>
	article {
		margin-inline: auto;
	}

	h1 {
		text-transform: none;
	}

	hgroup {
		margin-top: 0;
	}

	.banner {
		margin: 1.5rem 0 2rem;
		border-radius: 12px;
		overflow: hidden;
	}

	.banner :global(img) {
		width: 100%;
		aspect-ratio: 1200 / 628;
		object-fit: cover;
		display: block;
	}

	/* h1 + p {
		margin-top: var(--size-2);
		color: var(--text-2);
	} */

	/*.tags {
		display: flex;
		gap: var(--size-3);
		margin-top: var(--size-7);
	}

	.tags > * {
		padding: var(--size-2) var(--size-3);
		border-radius: var(--radius-round);
	}*/
</style>
